import { 
    achievementGraph, 
    affiliations, 
    assessmentExecutionTracking, 
    assessmentLibrary, 
    assessmentsStatus, 
    dashboard, 
    progressGraphs, 
    systemReview, 
    textReadability 
} from "router/routes";

/**
 * @typedef {Object} HiddenElements
 * @property {boolean} [pulldowns] - מציין האם להסתיר את התפריטים הנגללים (פילטרים בראש האתר).
 * @property {boolean} [padding] - מציין האם לבטל את הריווח (Padding) סביב התוכן.
 * @property {boolean} [header] - מציין האם להסתיר את ההאדר (Header) העליון.
 * @property {boolean} [sideBar] - מציין האם להסתיר את תפריט הצד (Sidebar).
 */

/**
 * אובייקט המגדיר אילו רכיבי ממשק משתמש (UI) יש להסתיר בכל נתיב.
 * משמש להתאמת התצוגה במסכים ייעודיים (הדרכות, מבדקים, וסקירות מערכת).
 * 
 * @type {Record<string, HiddenElements>}
 */
export const hideElementsInFeatures = {

    // ==========================================
    // אזור הדרכות (Tutorials)
    // ==========================================
    "tutorials/general": { pulldowns: true, padding: true },
    "tutorials/students": { pulldowns: true, padding: true },
    "tutorials/assessments": { pulldowns: true, padding: true },
    "tutorials/reports": { pulldowns: true, padding: true },

    // ==========================================
    // ביצוע מבדקים ומסכי מעבר (Assessments Execution)
    // תצוגה נקייה ללא תפריטים והאדר למניעת הסחות דעת
    // ==========================================
    "perform-assessments/:id": { header: true, sideBar: true },
    "perform-assessments/:id/preview": { header: true, sideBar: true },
    "practice-assessments/:id": { header: true, sideBar: true },
    "between/:id": { header: true, sideBar: true },
    "between/complete": { header: true, sideBar: true },
    "complete-screen": { header: true, sideBar: true },
    "mic-check": { header: true, sideBar: true },

    // ==========================================
    // סקירה מערכתית (System Review)
    // הסתרת הפילטרים בראש האתר
    // ==========================================
    [`${systemReview}/${assessmentExecutionTracking}`]: { pulldowns: true },
    [`${systemReview}/${assessmentsStatus}`]: { pulldowns: true },
    [`${systemReview}/${achievementGraph}`]: { pulldowns: true },
    [`${systemReview}/${progressGraphs}`]: { pulldowns: true },

    // ==========================================
    // ניהול, הגדרות ומסכים כלליים (Management & General)
    // ==========================================
    "users": { pulldowns: true },
    "newsletters": { pulldowns: true },
    "affiliations/:id": { pulldowns: true },
    "assessments/:id": { pulldowns: true },
    "tickets": { pulldowns: true },
    "child-development/normalizer": { pulldowns: true },
    "manage/marking-words/:id": { pulldowns: true },
    "assessment-library/new": { pulldowns: true },

    // ==========================================
    // ניתובים ראשיים דינמיים המיובאים מקובץ הראוטר
    // ==========================================
    [dashboard]: { pulldowns: true },
    [affiliations]: { pulldowns: true },
    [textReadability]: { pulldowns: true },
    [assessmentLibrary]: { pulldowns: true }
};